var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 21,
    viewBox: "0 0 60 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.07066 4.14132C3.25389 4.14132 4.16597 3.22924 4.14132 2.07066C4.14132 0.912076 3.25389 0 2.07066 0C0.936727 0 0.0246507 0.912076 0 2.07066C0 3.22924 0.936727 4.14132 2.07066 4.14132ZM0.271158 19.5973H3.89481V6.16268H0.271158V19.5973Z",
    fill: "#F79138"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73535 19.5973H17.3729C22.0172 19.5973 24.9166 17.5302 24.9166 14.2819C24.9166 11.8926 23.3864 10.2819 20.4065 9.69128C22.7421 9.10067 23.8696 7.22148 23.8696 5.18121C23.8696 1.98658 21.1313 0 16.7286 0H7.73535V19.5973ZM11.9501 8V3.51678H16.6749C18.5005 3.51678 19.5206 4.21477 19.5206 5.63758C19.5206 7.16779 18.5541 8 16.9434 8H11.9501ZM11.9501 16.0805V11.5436H17.3998C19.4132 11.5436 20.5676 12.349 20.5676 13.7987C20.5676 15.302 19.3595 16.0805 17.2656 16.0805H11.9501Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1246 11.866C42.1246 7.4096 39.3864 4.56396 35.0642 4.56396C30.5542 4.56396 27.4401 7.73175 27.4401 12.2687C27.4401 17.074 31.0105 20.0002 35.9233 20.0002C37.9367 20.0002 40.0038 19.5975 41.7488 18.6848L40.8092 15.7854C39.1716 16.4297 37.6414 16.7519 36.2723 16.7519C33.8562 16.7519 32.1112 15.7049 31.6548 13.3425H42.0441C42.1246 12.8593 42.1246 12.3224 42.1246 11.866ZM34.9837 7.67806C37.1045 7.67806 38.1783 9.02034 38.3125 10.9264H31.628C31.977 8.88611 33.2387 7.67806 34.9837 7.67806Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3327 19.5972H59.9501L51.6011 9.39584L48.1649 4.96631H43.5743L49.0508 12.1341L55.3327 19.5972Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7161 18.2986C45.7056 17.7559 46.3997 17.3641 46.7985 17.1232C48.9782 15.806 51.2041 14.0365 53.0085 12.535C55.407 10.5392 57.438 8.28587 57.5678 6.39398C57.7607 3.5827 54.7932 3.24877 50.3767 4.39839C49.4045 4.65147 47.8687 5.42886 45.7693 6.73056C46.0773 6.39463 46.3097 6.166 46.4666 6.04465C47.924 4.9169 49.3306 4.26003 50.4688 3.78922C52.6738 2.87718 54.9563 2.81378 56.6086 3.40085C58.3732 4.02787 59.8507 6.1852 58.6878 8.6414C57.7189 10.6876 56.4084 12.2961 54.2209 14.0951C52.7466 15.3076 50.6565 16.7576 48.7847 18.0516C48.2839 18.3977 47.1987 19.0472 45.5292 19.9999L44.7161 18.2986Z",
    fill: "#F79138",
    stroke: "#F79138",
    strokeWidth: 0.714354
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6011 9.39584L48.1649 4.96631H43.5743L49.0508 12.1341L51.6011 9.39584Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.79da157554536a9f9f672ad90656721f.svg";
export { ForwardRef as ReactComponent };